// removed by extract-text-webpack-plugin
module.exports = {"primaryColor":"#51A7E9","secondaryColor":"#79c5c5","backButtonColor":"#C5C5C5"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/element_variables.scss
// module id = yv97
// module chunks = 0